import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAdminAuth } from "@/hooks/useAdminAuth";
import { ADMIN_NEXT_KEY, takeAdminNext } from "@/lib/adminNext";

/**
 * After the Google sign-in redirect lands on the site root, send a signed-in
 * staff user to the admin page they asked for. Does nothing without a saved
 * destination, and never for visitors who are not signed-in staff.
 */
export default function AdminNextRedirect() {
  const { isViewer, loading } = useAdminAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const done = useRef(false);

  useEffect(() => {
    if (done.current || loading || !isViewer) return;
    let has = false;
    try { has = sessionStorage.getItem(ADMIN_NEXT_KEY) !== null; } catch { return; }
    if (!has) return;
    done.current = true;
    const path = takeAdminNext(sessionStorage);
    if (path && path !== location.pathname + location.search) navigate(path, { replace: true });
  }, [loading, isViewer, navigate, location.pathname, location.search]);

  return null;
}
